import * as React from 'react';
import { Breadcrumbs as RDCBreadcrumbs } from '@uncinc/react-drupal-core';

import './style.scss';

const Breadcrumbs: React.FC = () => {
  return (
    <RDCBreadcrumbs />
  );
};

export default Breadcrumbs;
